import { render, staticRenderFns } from "./AddExist.vue?vue&type=template&id=85f1d3c0&scoped=true"
import script from "./AddExist.vue?vue&type=script&lang=js"
export * from "./AddExist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f1d3c0",
  null
  
)

export default component.exports